/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
  Col,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import PercentageInput from 'components/PercentageInput';
import CurrencyInput from 'components/CurrencyInput';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import percentFormatter from 'utils/percentFormatter';
import { getIPEJALNominas, getIPEJALNominasPag } from 'api/nominas/IPEJALnominas';
import { getIPEJALNominasPercepciones, getIPEJALNominasPercepcionesPag } from 'api/nominas/IPEJALnominasPercepciones';
import { onError } from 'utils/handlers';
import percentFormatterNDecimals from 'utils/percentFormatterNdecimals';
import NominasPercepciones from './NominasPercepciones';

const NominasIPEJAL = ({ idParent, percepciones }) => {
  const [loading, setLoading] = useState(false);
  const [nominasPercepcionesIpejal, setNominasPercepcionesIpejal] = useState([]);
  const [nominasIpejal, setNominasIpejal] = useState([]);
  const [pageActualNominasPercepcionesIpejal, setPageActualNominasPercepcionesIpejal] = useState(1);
  const [pageActualNominasIpejal, setPageActualNominasIpejal] = useState(1);

  const fetchPaginatedNominasPercepciones = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIPEJALNominasPercepcionesPag({ page: cleanPage, ...q });

      const { results } = _data;

      // setSelectedRowKeys([]);
      setPageActualNominasPercepcionesIpejal(cleanPage);
      setNominasPercepcionesIpejal({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const fetchPaginatedNominas = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, ''));
      const _data = await getIPEJALNominasPag({ page: cleanPage, ...q });

      const { results } = _data;

      // setSelectedRowKeys([]);
      setPageActualNominasIpejal(cleanPage);
      setNominasIpejal({ ..._data, results: [...results] });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _IPEJALnominas,
        _IPEJALnominasPercepciones,
      ] = await Promise.all([
        getIPEJALNominas({ nomina_plaza: idParent[0] }),
        getIPEJALNominasPercepciones({ nomina_plaza: idParent[0] }),
      ]);
      setNominasIpejal(_IPEJALnominas);
      setNominasPercepcionesIpejal(_IPEJALnominasPercepciones);
      setLoading(false);
    };
    fetchAll();
  }, [idParent[0]]);

  const reduceFunction = (suma, actual) => suma + (actual.importe || 0);

  const totalPercepciones = nominasPercepcionesIpejal?.results?.reduce(reduceFunction, 0);
  const totalNominas = nominasIpejal?.results?.reduce(reduceFunction, 0);
  const columnsPercepcion = [
    {
      titleText: 'Percepción',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 200,
      render: (_, record) => {
        const descripcion = record?.percepcion?.descripcion || ' ';
        const clave = record?.percepcion?.clave || ' ';
        return `${clave} - ${descripcion}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 100,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const columnsNominas = [
    {
      titleText: 'Concepto',
      dataIndex: 'concepto',
      key: 'concepto',
      width: 100,
      render: (_, record) => record?.percepcion_configuracion_ipejal?.concepto_ipejal?.concepto || ' ',
    },
    {
      titleText: 'Base Gravable',
      dataIndex: 'base_gravable',
      key: 'base_gravable',
      width: 100,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Tasa',
      dataIndex: 'tasa',
      key: 'tasa',
      width: 100,
      align: 'right',
      render: (val) => percentFormatter(val || 0),
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 100,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const summaryCellsPercepcion = [
    {
      label: 'Total',
      value: totalPercepciones,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const summaryCellsNominasIpejal = [
    {
      label: 'Total',
      value: totalNominas,
      valueAlign: 'right',
      valueColSpan: 3,
      render: (val) => currencyFormatter(val || 0),
    },
  ];
  const rowSelection = {
    type: 'radio',
  };
  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columnsPercepcion}
          data={nominasPercepcionesIpejal?.results || []}
          pagination={false}
          paginationCallback={fetchPaginatedNominasPercepciones}
          count={nominasPercepcionesIpejal?.count || 0}
          rowSelection={rowSelection}
          currentPage={pageActualNominasPercepcionesIpejal}
          allowExportPDF={false}
          summaryCells={summaryCellsPercepcion}
        />
        <Table
          cols={columnsNominas}
          data={nominasIpejal?.results || []}
          pagination={false}
          paginationCallback={fetchPaginatedNominas}
          count={nominasIpejal?.count || 0}
          rowSelection={rowSelection}
          currentPage={pageActualNominasIpejal}
          allowExportParam={false}
          allowSearch={false}
          summaryCells={summaryCellsNominasIpejal}
        />
      </Spin>
    </Row>
  );
};

export default NominasIPEJAL;
